<!--盘点单镜架-->
<template>
  <el-dialog custom-class="medium-dialog" title="盘点单" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false"
             :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="仓库" :label-width="formLabelWidth" prop="cangkucode" size="small"
                        style="text-align: left;">
            <el-select v-model="form.cangkuname" placeholder="请选择" @change="changename"
                       :required="true" v-if="btnvisible">
              <el-option
                v-for="item in jxcstoreDataf"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item">
              </el-option>
            </el-select>
            <span v-else>{{form.cangkuname}}&nbsp;&nbsp;{{form.accdate}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商品分类" :label-width="formLabelWidth" prop="seedname" size="small"
                        style="text-align: left;">
            <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData" :isShowCheckBox="false" :selectpingpai="true"
                        v-model="form.seedname" :treeWidth="340" v-if="btnvisible"
                        :treeHeight="350" :searchText="form.seedname" :onlySelectChild="true"
                        @check="checktree1"></CommonTree>
            <span v-else>{{form.seedname}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <span v-if="btnvisible">{{pingpainame}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="false">
        <el-col :span="10">
          <el-form-item label="盘点日期" :label-width="formLabelWidth" prop="accdate">
            <el-input v-model="form.accdate" auto-complete="off" :required="true" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div style="float: left;width: 250px;padding-left:10px">
            {{subinfo}}
          </div>
          <div style="float: right;width: 300px">
            <el-button type="success" v-on:click="addFrame" v-if="btnvisible" size="mini">增 加</el-button>
            <el-button type="warning" v-on:click="jingjiaupload" v-if="btnvisible" size="mini">导 入</el-button>
            &nbsp;&nbsp;<a href="./static/file/镜架导入模板.xlsx" v-if="btnvisible">导入模板</a>
          </div>
          <div style="float: right;width: 300px;padding-right:30px">
            <el-input style="width: 120px" ref="searchmodelRef" v-model="searchmodel" auto-complete="off" placeholder="搜索型号" size="mini"  onfocus="this.select()"></el-input>
            <el-input style="width: 150px" size="mini" v-model="goodsbarcode" v-if="!scanAdd" @change="getBarCode()" placeholder="扫唯一码" onfocus="this.select()"></el-input>
          </div>
          <el-table
            ref="singleTable"
            :data="storetable.filter(data => !searchmodel || data.M.toLowerCase().includes(searchmodel.toLowerCase()))"
            :height="tableHeight(230)"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <el-table-column fixed
                             width="60"
                             type="index"
                             :index="indexMethod"
                             label="序号"
                             align="center">
            </el-table-column>
            <el-table-column
              prop="seedname"
              label="商品名称" :show-overflow-tooltip="true"
              align="left"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="seedcode"
              label="商品编码"
              align="left"
              header-align="center"
              width="140">
            </el-table-column>
            <el-table-column
              prop="goodyear"
              label="年份"
              align="left"
              header-align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="M"
              label="型号"
              align="left"
              header-align="center"
              width="120">
            </el-table-column>
            <el-table-column
              prop="C"
              label="色号"
              align="left"
              header-align="center"
              width="80">
            </el-table-column>
            <el-table-column
              prop="P"
              label="数量"
              align="left"
              width="100"
              header-align="center">
              <template slot-scope="scope">
                <el-input-number :ref='scope.row.id' v-model="scope.row.P" :controls="false" @change="subData" @focus="focus($event)" size="mini" style="width: 90px"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="tractnum"
              label="库存量"
              align="left"
              header-align="center" v-if="btnvisible&&!scanAdd"
              width="80">
            </el-table-column>
            <el-table-column
              label="差额"
              align="center"
              header-align="center" v-if="btnvisible&&!scanAdd"
              width="80">
              <template slot-scope="scope">
                <span> {{calNum(scope.row)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="备注：" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              :rows="1" v-if="btnvisible"
              v-model="form.remark">
            </el-input>
            <div v-else>{{form.remark}}</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="warning" @click="toZero(false)" plain v-if="btnvisible">清零</el-button>
      <el-button type="warning" @click="toFormat(false)" plain v-if="btnvisible&&!scanAdd">默认库存</el-button>
      <el-button type="primary" @click="saveData" v-if="btnvisible&&!scanAdd" :loading="loading">保 存</el-button>
      <el-button type="success" @click="delivergoodsScan" class="qrbtn" v-if="btnvisible&&scanAdd" :loading="loading">打码</el-button>
      <el-button type="text" size="mini" @click="exportExceltable" v-if="form.seedcode">导出</el-button>
      <input type="file" ref="fileupload" style="display: none;" @change="change1($event)"/>
      <MakeInventoryFrameAdd ref="MakeInventoryFrameAdd" @afterSelect="afterSelect"></MakeInventoryFrameAdd>
      <QRCodeScanBad ref="QRCodeScanBad1" @scancodeedit="afterQRCodeScan" :noScan="true"></QRCodeScanBad>
    </div>
  </el-dialog>
</template>

<script>
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getGoodsTree,listgoodsframe,jingjiaupload} from '@/api/set/jxcgooddetail';
  import {getControlData} from '@/api/set/goodsprice';
  import {inventorySave} from '@/api/set/jxcstoreform';
  import {looklist} from '@/api/set/jxcstoreformdetail';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {loadSpecFrame} from '@/plugin/ordercommon'
  import MakeInventoryFrameAdd from './MakeInventoryFrameAdd';
  import {getDetail as barcodeDetail} from '@/api/set/jxcstoregoodsbarcode';
  import {formatTimeToStr} from '@/plugin/Date';
  import QRCodeScanBad from './QRCodeScanBad';

  export default {
    name: 'MakeInventoryFrameEdit',
    msg: '盘点单',
    data() {
      return {
        addvisible: true,
        loading:false,
        guids: '',//商品编码
        dialogFormVisible: false,
        goodstable: [],//所有商品列表
        storetable: [],
        searchmodel:'',
        subinfo:'',
        pingpainame:'',
        scanAdd:false,//镜架 盘盈 打码
        goodsbarcode:'',
        selectgoodsbarcode:'',
        form: {  //表单数据
          accdate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
          cangkucode: '',
          cangkuname: '',
          packagesizes: '',
          seedcode: '',
          seedname: '',
          status: 10,
          formtype: 74,
          filltemplate: '',
          remark: '',
          totalnumber: 0,
          physicalstore:'',
          physicalstorecode:''
        },
        jxcstoreDataf: [],//仓库
        packagesizes: [],//存储盘点数据
        formLabelWidth: '120px',
        btnvisible: true,//控制确定按钮显示、隐藏
        rules: {////////定义正则验证字段。
          cangkucode: [
            {required: true, message: '请选择仓库', trigger: 'blur'},
          ],
          seedname: [
            {required: true, message: '请选择货品', trigger: 'change'},
          ],
        },
      }
    },
    methods: {
      error(msg) {
        this.$message({
          message: msg,
          type: 'error'
        })
      },
      exportExceltable() {
        let header1 = ["商品编码", "商品名称", "年份","型号", "色号",  "库存数"];
        let column1 = ["seedcode", "seedname", "goodyear","M", "C",  "tractnum"];

        var name = this.pingpainame + (this.form.seedname == this.pingpainame ? '' : this.form.seedname);
        var biaoti = []
        biaoti.push(formatTimeToStr(new Date()))
        biaoti.push("")
        biaoti.push("")
        biaoti.push(name)

        var data=[];
        var totalN=0;
        for(let i in this.storetable){
          totalN+=this.storetable[i].tractnum;
          data.push(this.storetable[i])
        }
        data.push({seedname:'合计',tractnum:totalN});

        name = name + formatTimeToStr(new Date());
        this.$exportExcel(header1, column1, data, name, biaoti)
      },
      getBarCode() {
        if (this.form.cangkucode && this.form.seedcode && this.form.seedcode.length >= 9) {

        } else {
          this.$message({
            message: '请先选择仓库以及商品系列！',
            type: 'warning'
          });
          this.goodsbarcode = '';
          return;
        }

        if (this.goodsbarcode == '')
          return;
        if (this.selectgoodsbarcode == '')
          this.selectgoodsbarcode = ';';

        if (this.selectgoodsbarcode.indexOf(';' + this.goodsbarcode + ';') > -1) {
          this.error('重复扫码！')
          this.goodsbarcode = '';
          return;
        }
        barcodeDetail({storegoodsbarcode: this.goodsbarcode}).then(response => {
          if (response.data.code == 0 && response.data.obj) {
            var arr = response.data.obj;
            if (arr.packagesize.indexOf('"M"') == -1) {
              this.error('非镜架商品！')
              this.goodsbarcode = '';
              return;
            }

            var barcode = this.goodsbarcode;
            this.selectgoodsbarcode += this.goodsbarcode + ';';
            this.goodsbarcode = '';
            var pg = JSON.parse(arr.packagesize);
            var good = null;
            for (let i in this.goodstable) {
              if (this.goodstable[i].seedcode == arr.seedcode) {//有对应的产品
                if (pg.C) {
                  if (this.goodstable[i].model == pg.M && (';' + this.goodstable[i].color + ';').indexOf(';' + pg.C + ';') > -1) {
                    good = this.goodstable[i];
                    break;
                  }
                } else {//没有填
                  if (this.goodstable[i].model == pg.M && this.goodstable[i].color == '') {
                    good = this.goodstable[i];
                    break;
                  }
                }
              }
            }
            if (good)
              this.afterSelect([{seedcode: good.seedcode, seedname: good.seedname, M: pg.M, C: pg.C, P: 1}]);
            else {
              this.error('非本系列商品！')
              this.goodsbarcode = '';
              return;
            }
          } else {
            this.goodsbarcode = '';
            this.error('产品编码不存在！')
          }
        });
      },
      //给scancodes 添加 id，共回车使用
      indexMethod(index) {
        this.storetable[index].id = index
        return index + 1;
      },
      addFrame(){
        if (this.form.cangkucode && this.form.seedcode && this.form.seedcode.length >= 9) {
          this.$refs.MakeInventoryFrameAdd.show(this.goodstable)
        } else {
          this.$message({
            message: '请先选择仓库以及商品系列！',
            type: 'warning'
          });
        }
      },
      focus(event) {
        event.currentTarget.select();
      },
      toFormat(){
        for (let i in this.storetable) {
          this.storetable[i].P=this.storetable[i].tractnum
        }
        this.subData();
      },
      toZero(){
        for (let i in this.storetable) {
          this.storetable[i].P=0
        }
        this.subData();
      },
      calNum(row) {
        if (!row.tractnum)
          row.tractnum = 0;
        if (!row.P)
          row.P = 0;
        if(row.P==row.tractnum)
          return '';
        return row.P-row.tractnum;
      },
      delivergoodsScan() {//扫码发货
        var arrContent=this.storetable;
        var arr=[];
        for (let i in arrContent) {
          if (arrContent[i].P > 0) {
            var handleNum = parseInt(arrContent[i].P);
            for (let m = 0; m < handleNum; m++) {
              arr.push({
                erpserial: '',
                seedcode: arrContent[i].seedcode,
                seedname: arrContent[i].seedname,
                packagesize: "{\"M\":\"" + arrContent[i].M + "\",\"C\":\"" + arrContent[i].C + "\"}",
                storegoodsbarcode: '', starttime: '', endtime: '',
                pipei: false
              })
            }
          }
        }
        if(arr.length==0)
          return;

        this.$refs.QRCodeScanBad1.show({
          cangkucode: this.form.cangkucode,
          erpserial: '',
          seedcode: '',
          goods: arr,
          tableData: [],
        }, true);
      },
      afterQRCodeScan(scancodes) {//扫码后提交
        this.saveData();
      },
      show(cangkucode) {
        this.changename({cangkucode:cangkucode});
        this.dialogFormVisible = true;
      },
      jingjiaupload() {
        if (this.form.cangkucode && this.form.seedcode && this.form.seedcode.length >= 9) {
          this.$refs.fileupload.value = ""
          this.$refs.fileupload.click()
        } else {
          this.$message({
            message: '请先选择仓库以及商品系列！',
            type: 'warning'
          });
        }
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
              var catename = this.pingpainame + this.form.seedname.replace(this.pingpainame, '')
              let arr = loadSpecFrame(data, this.form.seedcode, catename);
              if (arr.length > 0) {
                var modelList = '';
                for (var i in arr) {

                  var MandC = JSON.parse(arr[i].goodsframe)[0];
                  var hasValue = false;
                  for (var j in this.storetable) {
                    if (MandC.model == this.storetable[j].M && MandC.color == this.storetable[j].C) {//在库存里的
                      arr[i].seedcode = this.storetable[j].seedcode;
                      this.storetable[j].excelitem = arr[i];
                      this.storetable[j].P = arr[i].minnumber;
                      hasValue = true
                      break;
                    }
                  }
                  if (!hasValue) {
                    var item = {
                      "seedcode": "",
                      "seedname": arr[i].seedname,
                      "tractnum": 0,//当前库存数量
                      "M": MandC.model,
                      "C": MandC.color,
                      "excelitem": arr[i],
                      "P": arr[i].minnumber//盘点数量
                    };

                    for (var m in this.goodstable) {
                      if (this.goodstable[m].model == MandC.model && (";" + this.goodstable[m].color + ';').indexOf(";" + item.C + ";") > -1) {
                        item.seedcode = this.goodstable[m].seedcode;
                        item.seedname = this.goodstable[m].seedname;
                        break;
                      }
                    }
                    if (item.seedcode)
                      this.storetable.push(item);
                    else {
                      modelList += item.M + "-" + item.C + "、"
                    }
                  }
                }
                if (modelList) {
                  this.$message.error("型号-色号：" + modelList + " 在商品库中不存在，未导入！！")
                }
                this.sortTable();
              }
            }
          )
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      afterSelect(arr) {
        var needsort = false;
        for (var i in arr) {
          var MandC = arr[i];
          var hasValue = false;
          for (var j in this.storetable) {
            if (MandC.M == this.storetable[j].M && MandC.C == this.storetable[j].C) {//在库存里的
              this.storetable[j].excelitem = null;
              if (this.storetable[j].P == '' || this.storetable[j].P == null)
                this.storetable[j].P = 0;
              this.storetable[j].P += MandC.P;
              hasValue = true
              break;
            }
          }
          if (!hasValue) {
            var item = {
              "seedcode": MandC.seedcode,
              "seedname": MandC.seedname,
              "tractnum": 0,//当前库存数量
              "M": MandC.M,
              "C": MandC.C,
              "excelitem": null,
              "goodyear":MandC.goodyear,
              "P": MandC.P//盘点数量
            };
            needsort = true;
            this.storetable.push(item);
          }
        }
        if (needsort)
          this.sortTable();
        else{
          this.subData();
        }
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (!valid)
            return;

          this.loading = true
          var seedarr = [];
          for (let i in this.storetable) {
            if (this.storetable[i].P && parseInt(this.storetable[i].P) > 0) {//有盘点数量的
              if (this.storetable[i].excelitem && this.storetable[i].excelitem.goodsframe)
                seedarr.push(this.storetable[i].excelitem)
            }
          }

          //先补录产品
          // jingjiaupload({arr: JSON.stringify(seedarr)}).then(response => {
          //   if (response.data.code == 0) {
          //     var returnSeed = response.data.obj;
          //     if (returnSeed == null) returnSeed = [];

          var arr = [];
          for (let i in this.storetable) {
            var CY = (this.storetable[i].P ? parseInt(this.storetable[i].P) : 0) - (this.storetable[i].tractnum ? parseInt(this.storetable[i].tractnum) : 0);
            if (CY != 0) {//有差异数量的
              //补商品编码
              // if (this.storetable[i].seedcode == '' && this.storetable[i].excelitem && this.storetable[i].excelitem.goodsframe) {
              //   for (let j in returnSeed) {
              //     if (returnSeed[j].goodsframe == this.storetable[i].excelitem.goodsframe) {
              //       this.storetable[i].seedcode = returnSeed[j].seedcode
              //       this.storetable[i].seedname = returnSeed[j].seedname
              //       break;
              //     }
              //   }
              // }
              //this.storetable[i].excelitem = '';
              arr.push({
                "seedcode": this.storetable[i].seedcode,
                "seedname": this.storetable[i].seedname,
                "M": this.storetable[i].M,
                "C": this.storetable[i].C,
                "P": CY
              });
            }
          }
          this.form.remark = this.form.remark + '  ' + this.subinfo;
          if (arr.length == 0) {
          }
          for (let i in arr) {
            if (arr[i].seedcode == '') {
              this.$message({
                message: '商品不存在！',
                type: 'warning'
              })
              this.loading = false
              return
            }
          }

          this.form.packagesizes = JSON.stringify(arr);

          this.form.physicalstore = this.pingpainame + this.form.seedname.replace(this.pingpainame, '')
          this.form.physicalstorecode = ''
          inventorySave(this.form).then(response => {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            if (this.$refs.QRCodeScanBad1) {//盘盈时需要保存 唯一码
              this.$refs.QRCodeScanBad1.saveQRCode(response.data.msg);
            }
            this.dialogFormVisible = false;
            //刷新列表
            this.$emit('bindGrid');
          });
          // } else {
          //   this.$message({
          //     type: 'error',
          //     message: response.data.msg
          //   });
          //   this.loading = false
          // }
          // })
        })
      },
      initData(row) {
        this.initForm(false)
        this.btnvisible = false
        this.form.cangkucode = row.cangkucode
        this.form.cangkuname = row.cangkuname
        this.form.seedname=row.physicalstore;
        this.form.remark=row.remark;
        this.form.accdate = row.accdate;
        looklist({
          erpserial: row.erpserial,
          filltemplate: '80'
        }).then(response => {
          if(response.data.obj.packagesizes) {
            this.storetable = JSON.parse(response.data.obj.packagesizes)
            this.sortTable();
          }
        })

      },
      //初始化
      initForm(scanAdd) {
        this.scanAdd=scanAdd;
        this.goodstable = []
        this.selectgoodsbarcode=''
        this.storetable=[]
        this.form.seedcode = ""
        this.form.seedname = ""
        this.form.remark = ''
        this.form.totalnumber = 0
        this.form.cangkucode = ''
        this.form.cangkuname = ''
        this.loading=false
        this.btnvisible=true;
        this.form.enabled = 1
        this.index = ''
        if (this.$refs.treedept != undefined) {
          this.$refs.treedept.reset();
        }
        this.subData();

      },
      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType:true,categorystarts:'002;003;004;006'})
        })
      },
      //选择商品树所执行的方法
      checktree1(guids, names, arr) {
        this.form.seedcode = guids//分类编码
        this.form.seedname = names//商品名称
        this.pingpainame=this.form.seedcode.length==12?(this.$refs.treeSeed.getNode(guids.substr(0, guids.length - 3)).label):'';
        if (this.form.seedname == "") {
          this.$message({
            message: '请选择分类',
            type: 'warning'
          })
          return
        }

        this.getXYRange()
      },
      //二维表展示范围
      getXYRange() {
        //获取商品分类下的所有商品
        listgoodsframe({categorycode: this.form.seedcode,filltemplate:'80'}).then((response) => {
          //所有镜架商品
          this.goodstable =  response.data.obj;
          if (this.form.cangkucode) {
            if (this.btnvisible) {
              this.createPriceBook()
            } else {//查看状态

            }
          }
        })
      },
      changename(val) {
        this.form.cangkucode = val.cangkucode;
        for(let i in this.jxcstoreDataf){
          if(this.jxcstoreDataf[i].cangkucode==val.cangkucode){
            this.form.cangkuname = this.jxcstoreDataf[i].cangkuname;
            break;
          }
        }
        if (this.form.seedcode)
          this.createPriceBook()
      },
      subData(){
        var tSub=0
        var pSub=0;
        var cSub=0;
        for(let i in this.storetable) {
          var cn = this.calNum(this.storetable[i]);
          if (cn)
            cSub += cn;
          tSub += parseInt(this.storetable[i].tractnum);
          pSub += parseInt(this.storetable[i].P);
        }
        this.subinfo='盘点：'+pSub+' 、原库存：'+tSub+' 、'+(cSub==0?'无差异！':((cSub>0?'盘盈：':'盘亏：')+cSub));
      },
      sortTable() {
        this.storetable.sort(function (a, b) {
          if (a.M == b.M)
            return a.C.localeCompare(b.C)
          else
            return a.M.localeCompare(b.M)
        })
        this.subData();
      },
      createPriceBook() {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1

        var seedcodes=','
        for(let i in this.goodstable) {
          if (seedcodes.indexOf(',' + this.goodstable[i].seedcode + ',') == -1)
            seedcodes += this.goodstable[i].seedcode + ','
        }
        this.storetable=[]
        if(this.scanAdd)
          return;//纯粹扫码新增，不取库存

        //取当前库存
        getGoodsListWithStoreDetail({seedcode:seedcodes,
          cangkucode:this.form.cangkucode,
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1,nolimit:'1',notransfernum:'1',nodeliverying:'1',nobuynum:'1'}).then(resStore=> {

          var storeData = resStore.data.obj;
          if(storeData) {
            for (var i in storeData) {
              if(!storeData[i].packagesize) {
                console.log(storeData[i].packagesize);
                continue;
              }
              var packagesize = JSON.parse(storeData[i].packagesize);

              var seedname = '';
              var goodyear='';
              for (let j in this.goodstable) {
                if (this.goodstable[j].seedcode == storeData[i].seedcode) {
                  seedname = this.goodstable[j].seedname;
                  goodyear=this.goodstable[j].goodyear;
                  break;
                }
              }

              var item = {
                "seedcode": storeData[i].seedcode,
                "seedname": seedname,
                "tractnum": storeData[i].subtractnum,//当前库存数量
                "M": packagesize.M,
                "C": packagesize.C,
                "excelitem": [],
                "goodyear":goodyear,
                "P": storeData[i].subtractnum//盘点数量
              };
              if (storeData[i].subtractnum != 0)
                this.storetable.push(item)
            }
            this.sortTable();
          }
        });


      },
    },
    components: {
      MakeInventoryFrameAdd,
      QRCodeScanBad
    },

    mounted() {
      cusandptbyind().then(response => {
        this.jxcstoreDataf = response.data.obj
      })
    },
  }
</script>

<style scoped>
  .titlecolor {
    color: #20A0FF
  }

  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

</style>



// WEBPACK FOOTER //
// src/components/warehouse/MakeInventoryFrameEdit.vue